export default __webpack_public_path__ + "static/media/3.d67eeb8b.png";